export function prepareTryoutProfile(profile) {
  if (profile.kodeSubTipeCbt !== 'TRYOUT') return { ...profile };
  if (!profile.idKelasGroup || Number(profile.idKelasGroup) <= 0) {
    throw new Error('Pilih Kelas Group untuk tryout agar jadwal dapat dilihat siswa.');
  }
  return { ...profile, idKelas: null };
}
